import type { AnyObject, ObjectSchema } from 'yup';

import type { FormStepId } from 'shared/config/formStepId';

import type { TCreditFormCommonFields } from 'entities/creditForm';

import type { TStepValidationErrors } from './types';

export const validateStep = async (
  validationSchema: ObjectSchema<AnyObject>,
  formFields: Partial<TCreditFormCommonFields>,
  formStepId: ValuesOf<typeof FormStepId>,
  isAbortEarly = true,
): Promise<{
  isValid: boolean;
  errorStep: TStepValidationErrors | null;
}> => {
  try {
    await validationSchema.validate(formFields, { abortEarly: isAbortEarly });
  } catch (err) {
    const paths: Array<keyof TCreditFormCommonFields> = [err.path].flat().filter(Boolean);

    return {
      isValid: false,
      errorStep: {
        formStepId,
        errorFields: paths,
      },
    };
  }
  return {
    isValid: true,
    errorStep: null,
  };
};
